<template>
	<div class="list-group border-radius-2 no-border" v-if="loadedconfig">
		<WidgetHeader>{{ $t('progress') }}</WidgetHeader>
		<div class="list-group-item p-8">
			<Report
				:loadedconfig="loadedconfig"
				:studentid="$UserSession.getValue('id')"
				:showheaders="false"
			/>
		</div>
	</div>
</template>

<script>
import WidgetHeader from "./WidgetHeader";
import Report from "../Reports/Report";

export default {
	components: {
		WidgetHeader,
		Report
	},
	data() {
		return {
			loadedconfig: null
		};
	},
	mounted() {
		this.getReportConfig();
	},
	methods: {
		unableToGetSettings() {
			const self = this;
			this.$store.commit("openDialog" , {
				title: this.$t('oops'),
				content: this.$t('unable-to-get-report-settings'),
				confirmCallBack: function(){
					self.$router.replace('/');
				}
			});
		},
		getReportConfig(){
			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/report/teacherprogresswidget`, {
				cache: false,
				init: {
					method: "post",
					body: {
					}
				}
			})
			.then(json => {
				if (json.status === "SUCCESS") {
					this.$log.info.call(this, "Report config loaded");
					this.loadedconfig = json.result;
				} else {
					this.$log.error.call(this, "Could not fetch report widget settings");
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
		}
	}
};
</script>
